import type { MenuProps } from '@mui/material/Menu';

/** Prevents body scroll-lock flicker when dropdowns open on the landing page */
export const searchDropdownMenuProps: Partial<MenuProps> = {
  disableScrollLock: true,
  MenuListProps: {
    autoFocusItem: false,
  },
  PaperProps: {
    sx: {
      borderRadius: 2,
      mt: 1,
      boxShadow: '0 12px 40px rgba(15, 23, 42, 0.14)',
    },
  },
};
